var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationVosklSign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 19,
    viewBox: "0 0 3 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63672 0.9375L2.48438 13.1836H0.527344L0.363281 0.9375H2.63672ZM0.292969 16.9102C0.292969 16.5586 0.398438 16.2617 0.609375 16.0195C0.828125 15.7773 1.14844 15.6562 1.57031 15.6562C1.98438 15.6562 2.30078 15.7773 2.51953 16.0195C2.74609 16.2617 2.85938 16.5586 2.85938 16.9102C2.85938 17.2461 2.74609 17.5352 2.51953 17.7773C2.30078 18.0195 1.98438 18.1406 1.57031 18.1406C1.14844 18.1406 0.828125 18.0195 0.609375 17.7773C0.398438 17.5352 0.292969 17.2461 0.292969 16.9102Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationVosklSign);
export default __webpack_public_path__ + "static/media/notification_voskl_sign.894f3b678d328551a0da0933ba4dd30f.svg";
export { ForwardRef as ReactComponent };